import {Component, inject} from '@angular/core';
import {GridModel} from 'src/app/shared/model/page-grid';
import {AdxInvoiceLineItemGridService} from '../../service/adx-invoice-line-items-grid.service';
import {DatePipe} from '@angular/common';
import {Validators} from '@angular/forms';
import {InvoiceGridComponent} from '../invoice-grid/invoice-grid.component';

@Component({
    selector: 'app-adx-invoice-line-items',
    templateUrl: './adx-invoice-line-items.component.html',
    styles: [],
    imports: [
        InvoiceGridComponent
    ]
})
export class AdxInvoiceLineItemsComponent {
  private datePipe = inject(DatePipe);

  protected readonly adxInvoiceLineItemsGrid: GridModel<any> = {
    gridDataTestId: 'adx-invoice-line-items-list',
    gridTitle: 'Invoice Line Items',
    replayButton: true,
    defaultSort: {
      active: 'dateUpdated',
      direction: 'desc'
    },
    columns: [
      {
        columnProperty: 'fmsAdxInvoiceLineItemId',
        columnHeader: 'Invoice Number',
        sort: true,
        clickable: true,
        disablePreventEventLink: true,
        textLeft: true,
        linkEventFunction: (item:any)=> `${item.linkForInvoiceDetails}`,
        style: () => ({ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }),
      },
      {
        columnProperty: 'clientProfileNo',
        columnHeader: 'Client Profile Number',
        sort: true,
      },
      {
        columnProperty: 'clientName',
        columnHeader: 'Client Name',
        sort: true,
        textLeft: true,
      },
      {
        columnProperty: 'quoteID',
        columnHeader: 'Itinerary',
        sort: true,
      },
      {
        columnProperty: 'invoiceRecordLocator',
        columnHeader: 'Invoice Record Locator',
        sort: true,
      },
      {
        columnProperty: 'invoiceType',
        columnHeader: 'Invoice Type',
        sort: true,
      },
      {
        columnProperty: 'issueDate',
        columnHeader: 'Issue Date',
        sort: true,
        processData: (item)=> this.datePipe.transform(item, 'M/d/yyyy') ?? '',
      },
      {
        columnProperty: 'dateCreated',
        columnHeader: 'Date Created',
        sort: true,
        processData: (item)=> this.datePipe.transform(item, 'M/d/yyyy') ?? '',
      },
      {
        columnProperty: 'dateUpdated',
        columnHeader: 'Date Updated',
        sort: true,
        shouldHideColumn: true,
        processData: (item)=> this.datePipe.transform(item, 'M/d/yyyy') ?? '',
      },
    ],
    filters: [
      {
        filterDisplayName: 'Itinerary',
        filterProperty: 'quoteID',
        filterType: 'AUTOCOMPLETE',
        config: {
          autocompleteTableName: 'AdxInvoicePayloadView',
          autocompleteColumnName: 'QuoteId',
          autocompleteEmitText: true,
        },
        validators: [Validators.pattern(/^[1-9]\d*$/), Validators.min(1)],
      },
      {
        filterDisplayName: 'Invoice Record Locator',
        filterProperty: 'invoiceRecordLocator',
        filterType: 'AUTOCOMPLETE',
        config: {
          autocompleteTableName: 'AdxInvoicePayloadView',
          autocompleteColumnName: 'InvoiceRecordLocator',
          autocompleteEmitText: true,
        },
        validators: [Validators.pattern(/^\S*$/)],
      },
      {
        filterDisplayName: 'Invoice Type',
        filterProperty: 'invoiceType',
        filterType: 'AUTOCOMPLETE',
        config: {
          autocompleteTableName: 'AdxInvoicePayloadView',
          autocompleteColumnName: 'InvoiceType',
          autocompleteEmitText: true,
        },
      },
      {
        filterDisplayName: 'Client Profile Number',
        filterProperty: 'clientProfileNo',
        filterType: 'AUTOCOMPLETE',
        config: {
          autocompleteTableName: 'AdxInvoicePayloadView',
          autocompleteColumnName: 'ClientProfileNo',
          autocompleteEmitText: true,
        },
      },
      {
        filterDisplayName: 'Issue Start Date',
        filterProperty: 'issueStartDate',
        filterType: 'DATE',
      },
      {
        filterDisplayName: 'Issue End Date',
        filterProperty: 'issueEndDate',
        filterType: 'DATE',
      },
      {
        filterDisplayName: 'Create Start Date',
        filterProperty: 'createdStartDate',
        filterType: 'DATE',
      },
      {
        filterDisplayName: 'Create End Date',
        filterProperty: 'createdEndDate',
        filterType: 'DATE',
      },
    ],
    gridGetService: inject(AdxInvoiceLineItemGridService),
  };
}
